import { useMemo } from 'react';

import type { ShareActionsOptions } from '#src/app/shared/hooks/share';

import type { PartialComment, PartialPetition, ShareConfig } from '../types';

import { useGetCommentShareContent } from './content';
import { useGetCommentShareTrackingData } from './tracking';

export function useCommentShareOptions(
	comment: PartialComment,
	petition: PartialPetition,
	config: ShareConfig,
): ShareActionsOptions {
	const getContent = useGetCommentShareContent(comment);
	const getTrackingData = useGetCommentShareTrackingData(comment, petition, config);

	return useMemo(
		() => ({
			trackingEventName: 'comment_share',
			getContent,
			getTrackingData,
		}),
		[getContent, getTrackingData],
	);
}
